/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import React, { useState, useRef, useEffect, useCallback } from 'react';

import useSubscribed from '../../hooks/useSubscribed';
import useSubscriptionVariant from '../../hooks/useSubscriptionVariant';

// import classNames from 'classnames';
import SubscriptionBaseBanner from '../subscription/SubscriptionBanner';
import Banner from './Banner';

const propTypes = {
    subscription: PropTypes.string,
    variant: PropTypes.string,
    closePopup: PropTypes.func.isRequired,
};

const defaultProps = {
    subscription: null,
    variant: null,
};

function SubscriptionBanner({ closePopup, subscription, variant: providedVariant, ...props }) {
    const [opened, setOpened] = useState(false);
    const subscribed = useSubscribed();
    const refContainer = useRef(null);

    const { variant, markDone } = useSubscriptionVariant({
        subscription,
        variant: providedVariant,
        placement: 'banner',
        source: 'banner',
    });

    const onRequestClose = useCallback(() => {
        setOpened(false);
        markDone();
    }, [setOpened, markDone]);

    const onComplete = useCallback(() => {
        setOpened(false);
    }, [setOpened]);

    useEffect(() => {
        if (!subscribed || process.env.NODE_ENV !== 'production') {
            setOpened(true);
        } else {
            closePopup();
        }
    }, [setOpened]);

    return (
        <Banner
            onClickSafe={onRequestClose}
            onClosed={closePopup}
            opened={opened}
            innerRef={refContainer}
            position="bottom"
        >
            <SubscriptionBaseBanner
                {...variant}
                {...props}
                onClickClose={onRequestClose}
                onComplete={onComplete}
            />
        </Banner>
    );
}

SubscriptionBanner.propTypes = propTypes;
SubscriptionBanner.defaultProps = defaultProps;

export default SubscriptionBanner;
